import {Select} from '@hconnect/common/components'
import {FilterContrastProvider, selectFieldFilterSx} from '@hconnect/common/styles'
import {ExtendedShiftQuickSelectSlots, SelectOption} from '@hconnect/common/types'
import {Box} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {AREA_DASHBOARD_WIDGET_NAMESPACE} from '../consts'
import {useSlotParam} from '../hooks'

type AreaFilterContainerProps<T extends ExtendedShiftQuickSelectSlots> = {
  quickSelectSlots: T[]
  defaultSlot: T
}

export const AreaFilterContainer = <T extends ExtendedShiftQuickSelectSlots>({
  quickSelectSlots,
  defaultSlot
}: AreaFilterContainerProps<T>) => {
  const {t} = useTranslation(AREA_DASHBOARD_WIDGET_NAMESPACE)

  const {setTimeRange, slot} = useSlotParam<T>({
    key: 'timeRangeArea',
    defaultSlot
  })

  const slotOptions: SelectOption<T>[] = quickSelectSlots.map((slot) => ({
    label: t(`shiftEvent.quickSelection.${slot}`),
    value: slot
  }))

  const handleChange = (param: T | undefined) => {
    if (param) setTimeRange(param)
  }

  return (
    <FilterContrastProvider>
      <Box display="flex" gap={1} alignItems="center" flexWrap="wrap">
        <Select
          options={slotOptions}
          value={slot}
          sx={selectFieldFilterSx}
          onChange={handleChange}
          label={t('datePicker.label')}
          data-test-id="kpi-select"
        />
      </Box>
    </FilterContrastProvider>
  )
}
